export const SVGShapeEight = ({ colorOne }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.53 17.53">
    <path
      class={colorOne ? colorOne : "text-body"}
      d="M12.11,14.07a6.27,6.27,0,1,1,2-8.64A6.28,6.28,0,0,1,12.11,14.07Z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="5"
    />
  </svg>
);
